export const breakpoints = {
    mediumHeightMin: 'min-height: 769px',
    smallMin: 'min-width: 770px',
    mediumMin: 'min-width: 940px',
    largeMin: 'min-width: 1400px',
};

export const DESKTOP_BREAKPOINT = 940;
